import { Configuration, StoresApi } from '@/api';
import { StoreAssociation } from '@/models/Store';
import { useAuth } from '@/modules/auth/contexts/AuthContext';
import { useQuery, useQueryClient } from '@tanstack/react-query';

const useGetStoreQuery = (storeId?: string, supplierId?: string, include?: StoreAssociation[]) => {
  const queryClient = useQueryClient();

  const storesApi = new StoresApi(new Configuration(useAuth));

  const queryKey = supplierId
    ? ['store', storeId, supplierId, include ?? null]
    : ['store', storeId, include ?? null];

  const {
    isLoading,
    isFetching,
    data: store,
    error,
  } = useQuery({
    queryKey,
    queryFn: () => {
      if (!storeId) throw new Error('Missing storeId');
      return supplierId
        ? storesApi.getStoreWithSupplierContext(storeId, supplierId, include)
        : storesApi.getStore(storeId, include);
    },
    enabled: Boolean(storeId),
  });

  const invalidateQuery = async (alsoInvalidateList = false) => {
    await queryClient.invalidateQueries({ queryKey });

    if (alsoInvalidateList) {
      await queryClient.invalidateQueries({
        predicate: (query) => query.queryKey[0] === 'stores',
      });
    }
  };

  return {
    store,
    isLoading,
    isFetching,
    error,
    invalidateQuery,
  };
};

export default useGetStoreQuery;
